import { render, staticRenderFns } from "./Verified.vue?vue&type=template&id=4c542c14&scoped=true"
import script from "./Verified.vue?vue&type=script&lang=js"
export * from "./Verified.vue?vue&type=script&lang=js"
import style0 from "./Verified.vue?vue&type=style&index=0&id=4c542c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c542c14",
  null
  
)

export default component.exports